export default __webpack_public_path__ + "static/media/circleUpload.56a551cd.svg";